import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const I18N_LANGUAGES = ['de', 'en', 'es', 'fr', 'it', 'pl'] as const;
export type I18nLanguage = (typeof I18N_LANGUAGES)[number];
export type I18nLanguageRecord<T> = Record<I18nLanguage, T>;

@Pipe({
  name: 'onyxLanguage',
})
export class OnyxLanguagePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(value: I18nLanguageRecord<any>): string {
    const language = (this.translateService.getCurrentLang() ??
      this.translateService.getFallbackLang()) as I18nLanguage;
    return value[language] ?? '';
  }
}
